import { Button, Container, Modal } from 'react-bootstrap';
import { FaCopy, FaKey } from 'react-icons/fa';
import { toast } from 'react-toastify';

import { useLocalOrder } from '@/resources/hooks/useLocalOrder';
import { maskMoney } from '@/services/global';
import { IShipmentPayment } from '@/store/ducks/order/types';

interface PixPaymentProps {
  show: boolean;
  onHide: () => void;
}

export function PaggpixPayment({ show, onHide }: PixPaymentProps) {
  const order = useLocalOrder();

  const payment: IShipmentPayment | undefined = order?.payments?.find((p) => p.type === 'paggpix');

  const payment_qrcode = payment?.payment_qrcode || '';
  const total_paid = payment?.total_paid || 0;
  const pix_copy_code = payment?.pix_copy_code || '';

  const companyName = order?.company_name || '';
  const handleCopy = async () => {
    try {
      navigator.clipboard.writeText(pix_copy_code);
      toast.success('Código copiado com sucesso!');
    } catch (err) {
      toast.error(`Erro ao copiar o código. ${err}`);
    }
  };

  return (
    <Modal show={show} onHide={onHide} className="d-flex justify-content-center" centered size="sm">
      <Modal.Header className="d-flex justify-content-center align-items-center" closeButton>
        <label className="company-name text-center mb-0" title={companyName}>
          {companyName}
        </label>
      </Modal.Header>
      <Modal.Body>
        <Container className="pix-container d-flex flex-column montserrat  align-items-center">
          <strong
            className="fs-bolder d-flex flex-row justify-content-start "
            style={{ fontSize: 20, width: '100%' }}
          >
            Pagamento
          </strong>
          <div className="info-container details" style={{ color: 'gray' }}>
            Escaneie o quadrado ou copie o código abaixo para realizar o pagamento.
          </div>
          <div
            className="payment-price d-flex flex-row justify-content-start mt-2 fs-bolder ml-0 pl-0  "
            style={{ fontSize: 20, width: '100%' }}
          >
            Valor total: <strong className="fs-bolder ml-2">{maskMoney(total_paid, true)}</strong>
          </div>
          <div className="qrcode-container justify-content-center text-center my-3">
            <img
              className="img-fluid"
              src={payment_qrcode}
              title={pix_copy_code}
              alt="payment_qrcode"
              style={{ maxWidth: 220 }}
            />
          </div>
          <div className="pix-key-container d-flex flex-column justify-content-start w-100">
            <div className="pix-key-label mb-1 mr-auto d-flex align-items-center">
              <div
                className="key-icon"
                style={{
                  backgroundColor: '#3070d9',
                  width: '2rem',
                  height: '2rem',
                  borderRadius: '40%',
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <FaKey color="white" />
              </div>
              <label className="key-label mb-0 ml-1">Pix copia e cola: </label>
            </div>
            <div className="copy-and-paste d-flex align-items-center">
              {' '}
              <div
                className="copy-and-paste-code mt-2 mr-2 border-primary"
                style={{ userSelect: 'all', cursor: 'pointer' }}
                onClick={handleCopy}
                title="Clique para copiar"
              ></div>
              <textarea
                rows={3}
                value={pix_copy_code}
                readOnly
                style={{ borderRadius: '0.5rem' }}
                className="copy-and-paste-input border-primary w-100"
              />
            </div>
          </div>
        </Container>
      </Modal.Body>
      <div className="d-flex justify-content-center mb-3">
        <Button className="btn btn-primary copy-and-paste-btn d-flex flex-row" onClick={handleCopy}>
          Copiar código <FaCopy className="ml-2" />
        </Button>
      </div>
    </Modal>
  );
}
